import { c as _c } from "react/compiler-runtime";
import { Accordion, Button, Flex, HStack, Icon, Text } from '@chakra-ui/react';
import { ReactNode } from 'react';
import { LuCheck } from 'react-icons/lu';
export const StepBlock = t0 => {
  const $ = _c(33);
  const {
    n,
    title,
    value,
    isActive,
    isComplete,
    disabled,
    canContinue,
    onContinue,
    onContinueText,
    children
  } = t0;
  const t1 = isActive ? "colorPalette.card/30" : "colorPalette.card/20";
  const t2 = isActive ? "1px solid" : "none";
  const t3 = disabled ? 0.5 : 1;
  const t4 = isActive ? "1px solid" : "none";
  const t5 = isActive ? "none" : "lg";
  const t6 = disabled ? "not-allowed" : "pointer";
  const t7 = isComplete && !isActive ? "green.solid" : "colorPalette.solid";
  let t8;
  if ($[0] !== isActive || $[1] !== isComplete || $[2] !== n) {
    t8 = isComplete && !isActive ? <Icon boxSize={3.5}><LuCheck /></Icon> : n;
    $[0] = isActive;
    $[1] = isComplete;
    $[2] = n;
    $[3] = t8;
  } else {
    t8 = $[3];
  }
  let t9;
  if ($[4] !== t7 || $[5] !== t8) {
    t9 = <Flex align="center" bg={t7} borderRadius="full" boxSize={6} color="white" fontSize="xs" fontWeight="bold" justify="center">{t8}</Flex>;
    $[4] = t7;
    $[5] = t8;
    $[6] = t9;
  } else {
    t9 = $[6];
  }
  let t10;
  if ($[7] !== title) {
    t10 = <Text fontWeight="semibold">{title}</Text>;
    $[7] = title;
    $[8] = t10;
  } else {
    t10 = $[8];
  }
  let t11;
  if ($[9] !== t10 || $[10] !== t9) {
    t11 = <HStack as="span" flex={1} gap={2}>{t9}{t10}</HStack>;
    $[9] = t10;
    $[10] = t9;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Accordion.ItemIndicator />;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] !== t11 || $[14] !== t4 || $[15] !== t5 || $[16] !== t6) {
    t13 = <Accordion.ItemTrigger borderBottom={t4} borderBottomRadius={t5} borderColor="colorPalette.border/50" cursor={t6} padding={4}>{t11}{t12}</Accordion.ItemTrigger>;
    $[13] = t11;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== canContinue || $[19] !== onContinue || $[20] !== onContinueText) {
    t14 = onContinue && <HStack justify="flex-end" paddingTop={2}><Button disabled={canContinue === false} size="md" variant="cta" onClick={onContinue}>{onContinueText ?? "Continue"}</Button></HStack>;
    $[18] = canContinue;
    $[19] = onContinue;
    $[20] = onContinueText;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== children || $[23] !== t14) {
    t15 = <Accordion.ItemContent><Accordion.ItemBody display="flex" flexDirection="column" gap={4} padding={4}>{children}{t14}</Accordion.ItemBody></Accordion.ItemContent>;
    $[22] = children;
    $[23] = t14;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== disabled || $[26] !== t1 || $[27] !== t13 || $[28] !== t15 || $[29] !== t2 || $[30] !== t3 || $[31] !== value) {
    t16 = <Accordion.Item bgColor={t1} border={t2} borderColor="colorPalette.focusRing" borderRadius="md" disabled={disabled} marginBottom={2} opacity={t3} value={value}>{t13}{t15}</Accordion.Item>;
    $[25] = disabled;
    $[26] = t1;
    $[27] = t13;
    $[28] = t15;
    $[29] = t2;
    $[30] = t3;
    $[31] = value;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  return t16;
};